import getMuiTheme from 'material-ui/styles/getMuiTheme';

const colors = {
  primary: '#4a90e2',
  primaryAccent: '#1a71d7',
  primaryLight: '#91c0f6',
  textDark: '#4a4a4a',
  grey: '#9b9b9b',
  lightGrey: '#e5e5e5',
};

const muiTheme = getMuiTheme({
  fontFamily: 'Lato, Roboto, sans-serif',
  palette: {
    primary1Color: colors.primary,
    primary2Color: colors.primaryLight,
    primary3Color: colors.primaryAccent,
    accent1Color: '#e79309',
    accent2Color: '#52a1ff',
    accent3Color: '#52a1ff',
    textColor: colors.textDark,
    secondaryTextColor: '#9b9b9b',
    alternateTextColor: '#ffffff',
    canvasColor: '#ffffff',
    borderColor: '#e5e5e5',
    disabledColor: '#e5e5e5',
    pickerHeaderColor: colors.primary,
    clockCircleColor: colors.primary,
    shadowColor: '#000000',
  },
  toggle: {
    thumbOnColor: colors.primary,
    thumbOffColor: colors.grey,
    thumbDisabledColor: colors.lightGrey,
    thumbRequiredColor: 'red',
    trackOnColor: colors.primaryLight,
    trackOffColor: colors.lightGrey,
    trackDisabledColor: colors.lightGrey,
    labelColor: colors.textDark,
    labelDisabledColor: colors.grey,
    trackRequiredColor: 'red',
  },
  button: {
    borderRadius: 4,
  },
  flatButton: {
    textTransform: 'none',
  },
});

export default muiTheme;



// WEBPACK FOOTER //
// ./src/helpers/muiTheme.js